export const apiConstants = {
  getConfigurationData: "config/configuration-data",
  getUserPermissions: "Users/get-logged-in-user",
  getDeploymentPackageList: "software-package/get-all-zip-files",
  addPackage: "software-package/add-package",
  updatePackageStatus: "software-package",
  deletepackageBlob: "blob-storage",
  getUniqueDeviceId: "software-deployment-device/get-unique-deviceids",
  updateDeploymentStatus: "software-deployment-device/update-deployment-statuses",
  getProfileById: "package-deployment/get-profiles",
  findByName: "software-package/find-by-name",
  cancelSoftwarePackage: "devices/cancel-software-package",
  getHubSearchPropertyTemplate: "hub-search-property-template",
  createHubSearchPropertyTemplate: "hub-search-property-template/bulk-create",
  updateHubSearchPropertyTemplate: "hub-search-property-template/bulk-update",
  getDeviceTypeList: "device-types",
  getCountryList: "country",
  getDeviceOwner: "devices/device-owner",
  addDeviceType: "device-types/bulk-create",
  updateDeviceType: "device-types/bulk-update",
  deviceSearchQuery: "device-search-query",
  multipleDeviceUpdate: "devices/multiple-device-update/",
  getDeviceTwinByFilter: "devices/search",
  getDeviceTwinByFilterDeviceSearch: "devices/search/device",
  packageDeployment: "package-deployment",
  dbPropertiesList: "dbsearch-properties",
  getPackageDeploymentTwin: 'software-deployment-device/package-deployment-with-twins/',
  multipleTwinUpdate: "multiple-twin-update",
  updateDeviceSearchQuery: "update-device-search-query/",
  createDeviceSearchQuery: "create-device-search-query/",
  softwareDeploymentDeviceHistory: "software-deployment-device-history/re-deployment-history",
  getSoftwareDeploymentStatus: 'software-deployment-status',
  softwarePackageConfig: 'softwarePackageConfig',
  updateDeploymentStatusPackage: 'software-deployment-device/update-deployment-statuses-package-config',
  userList: "users",
  getPermissionTemplates: "users/templates",
  addUser: "users",
  tokenBlacklist : "logout/token-blacklist",
  packageDeploymentContry: 'software-deployment-device/package-deployment-country',
  dashboardGetDeploymentInfo: 'dashboard/get-deployment-information',
  sendEmailNotificationForDeploymentApproval: 'notification-email/send',
  deleteDeploymentProfile: 'package-deployment/delete-profile',
  getProfilesPendingApproval: "package-deployment/get-profiles-pending-approval",
  getDevicesByPackageId: "software-deployment-device/package-deployment",
  updateDeploymentStatusDevice: 'software-deployment-device/update-deployment-statuses-devices',
  getSoftwareDeployedDeviceIds: "software-deployment-device/get-software-deployed-deviceIds",
  saveUserLoginLog: "user-login/save-user-login",
  saveExportEventLog: "logging/save-export-event-log"

}
